import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinearIndeterminate(props: { visible: boolean }) {
    return (
        <Box sx={{ width: '100%', paddingTop: 1, paddingBottom: 1, visibility: props.visible ? '' : 'hidden' }}>
            <LinearProgress />
        </Box>
    );
}